import type { EfaxSearchState } from '../types';

const SEARCH_KEYS: (keyof EfaxSearchState)[] = [
  'documentName',
  'documentId',
  'documentReceivedAt',
  'documentStatus',
  'documentProfileId',
  'patientName',
  'patientDob',
  'patientReferenceId',
  'patientKey',
  'providerName',
  'providerFacilityName',
  'providerType',
  'receivingProviderName',
  'receivingProviderFacilityName',
  'receivingProviderType',
];

export const isSameEfaxSearch = (
  left: EfaxSearchState,
  right: EfaxSearchState,
) =>
  SEARCH_KEYS.every((key) => {
    const leftValue = left[key];
    const rightValue = right[key];

    if (leftValue instanceof Date && rightValue instanceof Date) {
      return leftValue.getTime() === rightValue.getTime();
    }

    return leftValue === rightValue;
  });

export const isEmptyEfaxSearch = (search: EfaxSearchState) =>
  SEARCH_KEYS.every((key) => {
    const value = search[key];

    if (value instanceof Date) {
      return false;
    }

    return value === undefined || value === '';
  });
